import React, { useContext } from 'react';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';
import Tooltip from 'components/Tooltip';
import DateInputContext from 'contexts/DateInputContext';
import DatePickerTriggerContext from 'contexts/DatePickerTriggerContext';
import { useRightText } from 'components/DateInput';
import toSentenceCase from 'services/toSentenceCase';
import { getLabel } from 'components/DateInput/RelativeInput/RelativeDateBuilder';

const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: var(--color-grey-1);

  &:hover {
    background-color: var(--color-bg-hover);
  }
`;

const getRelativeDateLabel = (r: RelativeDateRange): string => {
  const { type, n, interval, currentToDate } = r;
  const intervalLabel = getLabel(r, interval);
  const label =
    type === 'current'
      ? `${toSentenceCase(type)} ${intervalLabel}`
      : `${toSentenceCase(type)} ${n} ${intervalLabel}`;
  return currentToDate ? `${label} to Date` : label;
};

export const useDateLabel = () => {
  const { relativeDateRange, advancedRelativeDateRange } =
    useContext(DateInputContext);
  const rightText = useRightText();

  if (relativeDateRange) return getRelativeDateLabel(relativeDateRange);
  if (advancedRelativeDateRange) return 'Rolling';
  return rightText;
};

const DateFilterTrigger = () => {
  const { openDatePicker } = useContext(DatePickerTriggerContext);
  const label = useDateLabel();

  return (
    <Tooltip content={label} position="top">
      <TriggerButton
        data-testid="date-filter-trigger"
        onClick={(e) => {
          e.stopPropagation();
          openDatePicker();
        }}
      >
        <Icon icon="filters" width={14} height={14} />
      </TriggerButton>
    </Tooltip>
  );
};

export default DateFilterTrigger;
